import { useContext } from 'react';
import axios from 'axios'
import { useHistory } from 'react-router-dom';

import { removeStorageKey } from '../core/utils/storage';
import { SettingsContext } from '../contexts/index.jsx';

export function useMerchantStripe() {
  const history = useHistory();
  const { retailCircleToken } = useContext(SettingsContext);

  const goToStripeManagementPage = async (user, token, newTab = false, logout = false) => {
    if (!user.active_plan) {
      history.push(`/merchant-pricing-table?retail_circle=${retailCircleToken}&uuid=${user.uuid}&email=${user.email}`);
    } else {
      const response = await axios.post(`/api/merchant/${user.id}/stripe-portal`, {
        return_url: `${window.RETAIL_CIRCLE_DOMAIN}/manage-account`
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (logout) {
        removeStorageKey('user');
        removeStorageKey('token');
      }

      if (newTab) {
        window.open(response.data.url, '_blank');
      } else {
        window.parent.postMessage({ type: 'redirect', url: response.data.url }, '*');
      }
    }
  }

  return {
    goToStripeManagementPage
  };
}
